import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { CookiesProvider } from "react-cookie";
import App from "./App";
import AuthMiddleware from "./Helpers/AuthMiddleware";
import { store } from "./redux/store";
import "./App.scss";
import theme from "./Theme";
import { ThemeProvider } from "@mui/material/styles";
import { LanguageProvider } from "./LanguageProvider";


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <LanguageProvider>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <CookiesProvider>
            <AuthMiddleware>
              <App />
            </AuthMiddleware>
          </CookiesProvider>
        </ThemeProvider>
      </Provider>
    </LanguageProvider>
  </React.StrictMode>
);
